import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { SecurityManager } from './app.sec.component';




@Injectable()
export class Services {
  baseUrl = 'https://api.planeto.ir/api'
  constructor(
    private http: HttpClient
    , private security: SecurityManager) {


  }

  siginUser(userInfo) {

    return this.http.post(this.baseUrl + `/user/login`, userInfo)

  }
  confirmation(code) {
    return this.http.post(this.baseUrl + `/user/confirmation`, code)

  }
  logout() {
    return this.http.post(this.baseUrl + `/user/logout`, Object.assign({}, this.security.getToken()))

  }
  getSettings() {
    return this.http.post(this.baseUrl + `/user/getsettings`, Object.assign({}, this.security.getToken()))

  }
  getProfile() {

    return this.http.post(this.baseUrl + `/user/getprofile`, Object.assign({}, this.security.getToken()))

  }



  terminateSession(session) {

    return this.http.post(this.baseUrl + `/user/logout`, session)

  }

  setProfile(profile) {
    return this.http.post(this.baseUrl + `/user/setprofile`, Object.assign(profile, this.security.getToken()))

  }
  getCardList(options) {
    return this.http.post(this.baseUrl + `/card/getcardlist`, Object.assign(options, this.security.getToken()))

  }
  moveCard() {
    return this.http.post(this.baseUrl + `/card/movecard`, Object.assign({}, this.security.getToken))

  }
  deleteCard(info) {

    return this.http.post(this.baseUrl + `/card/DeleteCard`, Object.assign(info, this.security.getToken()))

  }
  saveCard(card) {

    return this.http.post(this.baseUrl + `/card/CreateCard`, Object.assign(card, this.security.getToken()))

  }
  updateCard(card) {
    return this.http.post(this.baseUrl + `/card/UpdateCard`, Object.assign(card, this.security.getToken()))

  }
  setCardDone(card) {
    return this.http.post(this.baseUrl + `/card/ChangeCardDoneState`, Object.assign(card, this.security.getToken()))

  }
  getCard(card) {
    return this.http.post(this.baseUrl + `/card/getCard`, Object.assign({ ID: card.CardGUID }, this.security.getToken()))

  }

  GetCardsByKeyword(keyword) {
    return this.http.post(this.baseUrl + `/card/GetCardsByKeyword`, Object.assign(keyword, this.security.getToken()))

  }
}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.service.ts